module.exports = __webpack_public_path__ + "static/dom-booth-banner-a768b29dcb52d0d4d80a5b9ea1f8d73e.png";